import { IconComponent } from './types';

const CloudIcon: IconComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="currentColor"
        d="M9.675 5.02a3.745 3.745 0 0 0-7-1A2.997 2.997 0 0 0 0 7c0 1.655 1.345 3 3 3h6.5A2.5 2.5 0 0 0 12 7.5c0-1.32-1.025-2.39-2.325-2.48ZM9.5 9H3a2 2 0 1 1 0-4h.355a2.75 2.75 0 0 1 5.395.75V6h.75c.83 0 1.5.67 1.5 1.5S10.33 9 9.5 9Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h12v12H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default CloudIcon;
